import { connect } from "react-redux";
import HomeComponent from "../Components/HomeComponent";

const mapStateToProps = (state) => {
  return {
    ACTIVE_TENANT: state.ACTIVE_TENANT,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const HomeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeComponent);

export default HomeContainer;
